module.exports = __webpack_public_path__ + "static/footer-logo-d6ae5bfeba08cb428d93e473888b27ef.svg";